import React from "react";
import {
  Table,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { connect } from "react-redux";
import {
  getSport,
  getRound,
  GameListBYSportId,
  getladder,
  GamelistSecretComp,
  TpppingCount,
  getTeam,
} from "../admin/actions/adminActions";
import question from "../../img/ant-design_question.svg";
import circle from "../../img/cil_check-circle.svg";
import close from "../../img/close-circle-outline.svg";
import adminTip from "../../img/tips_blank.png";
import Tipdistribution from "./Tipdistribution";
import { Spin, Pagination } from "antd";
import user from "../../img/user_placeholder.png";
import { PROFILE_IMG_PATH } from "../../actions/utilAction";

interface SportItem {
  _id: string;
  sportname: string;
}

interface TeamItem {
  _id: string;
  teamname: string;
}

interface GameItem {
  homeTeam?: { teamLogo?: string; teamname?: string };
  awayTeam?: { teamLogo?: string; teamname?: string };
  gameState?: string;
  tippingAddedBy?: string;
  tipping?: string;
  winningTeam?: string;
}

interface SecretRow {
  profilePhoto?: string;
  name?: string;
  roundpoint?: number;
  seasonPoints?: number;
  games: GameItem[];
}

interface RoundItem {
  _id: string;
  roundname: string;
  startDate: string;
  endDate: string;
}

interface TippingCount {
  usercount?: number;
  [key: string]: any;
}

interface SecretCompProps {
  getSport: (payload: any) => Promise<SportItem[]> | any;
  GameListBYSportId: (payload: any) => any;
  getladder: (payload: any) => any;
  GamelistSecretComp: (payload: any) => Promise<any>;
  TpppingCount: (payload: any) => Promise<TippingCount>;
  getTeam: (payload: any) => any;
  getRound: (payload: any) => Promise<{ data: RoundItem[] }> | any;
  totalCount: number;
  sportData: SportItem[];
  teamData: TeamItem[];
}

interface SecretCompState {
  sportDropdownOpen: boolean;
  roundDropdownOpen: boolean;
  filterDropdownOpen: boolean;
  selectedSport: string;
  selectedFilter: string;
  sportData: SportItem[];
  gameData: any[];
  ladderData: any[];
  secretCompGameDate: SecretRow[];
  sportId: string | null;
  teamId: string | null;
  TippingCount: TippingCount;
  loading: boolean;
  teamData: TeamItem[];
  gameName: string;
  roundList: RoundItem[];
  selectedRoundID: string;
  selectedRoundName: string;
  currentPage: number;
  totalPage: number;
  limit: number;
  sortValue: string;
  sortOrder: number; // -1 for descending, 1 for ascending
  totalRecord?: number;
}

class SecretComp extends React.Component<SecretCompProps, SecretCompState> {
  constructor(props: SecretCompProps) {
    super(props);
    this.state = {
      sportDropdownOpen: false,
      roundDropdownOpen: false,
      filterDropdownOpen: false,
      selectedSport: "",
      selectedFilter: "All Teams",
      sportData: [],
      gameData: [],
      ladderData: [],
      secretCompGameDate: [],
      sportId: null,
      teamId: null,
      TippingCount: {},
      loading: true,
      teamData: [],
      gameName: "",
      roundList: [],
      selectedRoundID: "",
      selectedRoundName: "",
      currentPage: 0,
      totalPage: 0,
      limit: 30,
      sortValue: "",
      sortOrder: -1,
      totalRecord: 0,
    };
  }
  toggleSportDropdown = () => {
    this.setState((prevState) => ({
      sportDropdownOpen: !prevState.sportDropdownOpen,
    }));
  };
  toggleFilterDropdown = () => {
    this.setState((prevState) => ({
      filterDropdownOpen: !prevState.filterDropdownOpen,
    }));
  };
  toggleRoundDropdown = () => {
    this.setState((prevState) => ({
      roundDropdownOpen: !prevState.roundDropdownOpen,
    }));
  };
  //on sport selection
  handleSportSelection = (sport: string, _id: string) => {
    this.setState({
      selectedSport: sport,
      sportId: _id,
      selectedFilter: "All Game",
    });
    this.handelTeam(_id);
    this.handelRound(_id);
  };
  async handelRound(id: string) {
    try {
      const obj = {
        sportId: id,
        sortValue: "createdAt",
        sortOrder: 1,
        count: 50,
      };

      const res = await this.props.getRound(obj);
      const currentDate = new Date();
      const formattedDate = currentDate.toISOString();
      const currentRound = res.data.filter((ele: RoundItem) => {
        const startDateUtcDate = new Date(ele.startDate).toISOString().split("T")[0];
        const endDateUtcDate = new Date(ele.endDate).toISOString().split("T")[0];
        const formattedDateUtcDate = new Date(formattedDate).toISOString().split("T")[0];
        return startDateUtcDate <= formattedDateUtcDate && formattedDateUtcDate <= endDateUtcDate;
      });

      const data = currentRound[0];
      if (data) {
        this.setState({
          roundList: res.data,
          selectedRoundID: data._id,
          selectedRoundName: data?.roundname,
        });
        await this.handelgameDate(id, "", data._id);
        await this.handeTippingCount(id, data._id);
      }
    } catch {
      // Round fetch failed - component will show empty state
    }
  }

  handelSelectRound(round: RoundItem) {
    this.setState({
      selectedRoundID: round?._id,
      selectedRoundName: round?.roundname,
    });
    this.handelgameDate(this.state.sportId, "", round?._id);
    this.handeTippingCount(this.state.sportId as string, round?._id);
  }
  //handel team selection
  handleFilterSelection = (filter: string, id: string) => {
    this.setState({
      selectedFilter: filter,
      teamId: id,
    });
    this.handelgameDate(this.state.sportId, id, this.state.selectedRoundID);
  };
  //get Point Ladder and game data
  handelgameDate = async (
    sportID: string | null,
    teamId: string | null,
    roundID: string,
    pagination?: { page: number }
  ) => {
    if (!sportID || !roundID) return;
    this.setState({ loading: true });
    try {
      const res = await this.props.GamelistSecretComp({
        round: roundID,
        sport: sportID,
        teamId,
        limit: this.state.limit,
        sortValue: this.state.sortValue,
        sortOrder: this.state.sortOrder,
        ...pagination,
      });
      this.setState({
        secretCompGameDate: res.docs || [],
        currentPage: res.page || 1,
        totalPage: res.totalPages || 0,
        loading: false,
      });
    } catch {
      this.setState({ loading: false });
    }
  };

  //get tiipping count
  handeTippingCount = async (sport: string, round: string, limit?: number) => {
    this.setState({ loading: true });
    try {
      const res = await this.props.TpppingCount({ sport, round, limit });
      this.setState({ TippingCount: res, loading: false });
    } catch {
      this.setState({ loading: false });
    }
  };

  //get team list using sport id
  handelTeam(sportId: string) {
    const obj1 = {
      sport: sportId,
      count: 1000,
    };
    this.props.getTeam(obj1);
  }
  async componentDidMount() {
    try {
      const obj1 = {
        count: 1000,
        isActive: true,
      };
      const sportData = await this.props.getSport(obj1);
      if (sportData && sportData.length > 0) {
        const selectedSport = sportData[0]?.sportname;

        this.setState({
          sportData,
          loading: false,
          sportId: sportData[0]?._id,
          selectedSport,
        });
        this.handelTeam(sportData[0]?._id);
        this.handelRound(sportData[0]?._id);
      } else {
        this.setState({ loading: false });
      }
    } catch {
      this.setState({ loading: false });
    }
  }
  changePage(page: number, pageSize?: number) {
    this.setState({
      currentPage: page,
    });
    const obj = {
      page: page,
    };
    this.handelgameDate(
      this.state.sportId,
      this.state.teamId,
      this.state.selectedRoundID,
      obj
    );
  }

  // Sort data handler
  sortData = (sortVal: string) => {
    const newSortOrder =
      this.state.sortValue === sortVal ? (this.state.sortOrder === -1 ? 1 : -1) : -1;

    this.setState(
      {
        sortOrder: newSortOrder,
        sortValue: sortVal,
      },
      () => {
        this.handelgameDate(
          this.state.sportId,
          this.state.teamId,
          this.state.selectedRoundID,
          { page: 1 }
        );
      }
    );
  };
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps: SecretCompProps) {
    const data = nextProps.teamData;
    this.setState({
      teamData: data,
      totalRecord: nextProps.totalCount,
      loading: false,
    });
  }
  render() {
    return (
      <>
        <h2 className="page-heading">SecretComp</h2>
        <div className="box box-default mb-4">
          <Spin spinning={this.state.loading} delay={500}>
            <div className="box-body secret_comp_main">
              <div className="table-responsive secret_comp">
                <Table>
                  <thead>
                    <tr>
                      <th>
                        Sport:
                        <Dropdown
                          isOpen={this.state.sportDropdownOpen}
                          toggle={this.toggleSportDropdown}
                        >
                          <DropdownToggle caret>
                            {this.state.selectedSport}
                          </DropdownToggle>
                          <DropdownMenu>
                            {this.state.sportData.map((sport, index) => (
                              <DropdownItem
                                key={index}
                                onClick={() =>
                                  this.handleSportSelection(
                                    sport?.sportname,
                                    sport?._id
                                  )
                                }
                              >
                                {sport?.sportname}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </th>
                      <th>
                        Round:
                        <Dropdown
                          isOpen={this.state.roundDropdownOpen}
                          toggle={this.toggleRoundDropdown}
                        >
                          <DropdownToggle caret>
                            {this.state.selectedRoundName}
                          </DropdownToggle>
                          <DropdownMenu>
                            {this.state.roundList.map((round, index) => (
                              <DropdownItem
                                key={index}
                                onClick={() => this.handelSelectRound(round)}
                              >
                                {round?.roundname}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </th>
                      <th>
                        Teams:
                        <Dropdown
                          isOpen={this.state.filterDropdownOpen}
                          toggle={this.toggleFilterDropdown}
                        >
                          <DropdownToggle caret>
                            {this.state.selectedFilter}
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={() =>
                                this.handleFilterSelection("All Games", "")
                              }
                            >
                              All Games
                            </DropdownItem>
                            {this.state.teamData.map((team, index) => (
                              <DropdownItem
                                key={index}
                                onClick={() =>
                                  this.handleFilterSelection(
                                    team?.teamname,
                                    team?._id
                                  )
                                }
                              >
                                {team?.teamname}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </th>
                      <th>
                        Active users: {this.state.TippingCount?.usercount || 0}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan={4} className="ladder">
                        <span>Ladder</span>
                        <span className="reveal">Reveal</span>
                        <table className="inner-table text-left">
                          <thead>
                            <tr>
                              <th colSpan={2}>User</th>
                              <th colSpan={1}>Rank</th>
                              <th
                                colSpan={1}
                                onClick={() => this.sortData("roundpoint")}
                                className="cursor-pointer"
                                style={{ cursor: "pointer" }}
                              >
                                Round Point{" "}
                                {this.state.sortValue === "roundpoint" ? (
                                  this.state.sortOrder === 1 ? (
                                    <i
                                      className="fa fa-sort-amount-asc"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i
                                      className="fa fa-sort-amount-desc"
                                      aria-hidden="true"
                                    ></i>
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort"
                                    aria-hidden="true"
                                  ></i>
                                )}
                              </th>
                              <th
                                colSpan={1}
                                onClick={() => this.sortData("seasonPoints")}
                                className="cursor-pointer"
                                style={{ cursor: "pointer" }}
                              >
                                Session Point{" "}
                                {this.state.sortValue === "seasonPoints" ? (
                                  this.state.sortOrder === 1 ? (
                                    <i
                                      className="fa fa-sort-amount-asc"
                                      aria-hidden="true"
                                    ></i>
                                  ) : (
                                    <i
                                      className="fa fa-sort-amount-desc"
                                      aria-hidden="true"
                                    ></i>
                                  )
                                ) : (
                                  <i
                                    className="fa fa-sort"
                                    aria-hidden="true"
                                  ></i>
                                )}
                              </th>
                              {this.state.secretCompGameDate[0]?.games.map(
                                (ele, i) => {
                                  return <th key={i}>{i + 1}</th>;
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.secretCompGameDate.map(
                              (data, index) => {
                                const rank =
                                  index +
                                  (this.state.currentPage - 1) *
                                    this.state.limit;
                                return (
                                  <tr key={index}>
                                    <td>
                                      <img
                                        src={
                                          data?.profilePhoto
                                            ? PROFILE_IMG_PATH +
                                              data?.profilePhoto
                                            : user
                                        }
                                        alt="user"
                                      />
                                    </td>
                                    <td>{data?.name}</td>
                                    <td>{rank + 1}</td>
                                    <td>{data?.roundpoint?.toFixed(2)}</td>
                                    <td>{data?.seasonPoints}</td>
                                    {data.games.map((ele, i) => {
                                      const imgLogo = (g: GameItem) => {
                                        if (
                                          g?.gameState === "started" ||
                                          g?.gameState === "finished" ||
                                          g?.gameState === "open"
                                        ) {
                                          const logos: any = {
                                            home: g?.homeTeam?.teamLogo,
                                            away: g?.awayTeam?.teamLogo,
                                          };
                                          return g?.tippingAddedBy === "admin"
                                            ? adminTip
                                            : logos[g.tipping as string];
                                        } else {
                                          return question;
                                        }
                                      };

                                      const winingLogo =
                                        (ele?.winningTeam || "").toLowerCase() ===
                                        (ele?.tipping || "").toLowerCase();

                                      return (
                                        <td className="image_flag" key={i}>
                                          <img
                                            src={imgLogo(ele) || question}
                                            alt="tip"
                                          />
                                          <span>
                                            {ele.winningTeam !== "" ? (
                                              <img
                                                src={
                                                  winingLogo ? circle : close
                                                }
                                                alt="status"
                                              />
                                            ) : null}
                                          </span>
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              }
                            )}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Pagination
                  style={{ textAlign: "right" }}
                  pageSize={this.state.limit}
                  defaultCurrent={this.state.currentPage}
                  total={this.state.TippingCount?.usercount || 0}
                  onChange={this.changePage.bind(this)}
                />
              </div>
              <Tipdistribution
                data={this.state.TippingCount}
                sportId={this.state.sportId}
                handeTippingCount={this.handeTippingCount as any}
              />
            </div>
          </Spin>
        </div>
      </>
    );
  }
}

function mapStateToProps(state: any) {
  return {
    totalCount: state.admin.roundCount,
    sportData: state.admin.sportData,
    gameData: state.admin.gameData,
    ladderData: state.admin.ladderData,
    secretCompGameDate: state.admin.secretCompGameDate,
    teamData: state.admin.teamData,
  };
}
export default connect(mapStateToProps, {
  getSport,
  GameListBYSportId,
  getladder,
  GamelistSecretComp,
  TpppingCount,
  getTeam,
  getRound,
})(SecretComp as any);












